var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-385.000000, -536.000000)",
    stroke: "#FE815F",
    strokeWidth: 1.944
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(360.000000, 512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7.776,
    y1: 0,
    x2: 7.776,
    y2: 16.596,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 7.776 7.776 0 15.552 7.776"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpActive);
export default __webpack_public_path__ + "static/media/up-active.2933364416abe9c9444efefe0531215f.svg";
export { ForwardRef as ReactComponent };